import AuthRoute from 'Routes/components/AuthRoute';
import Access from 'containers/Access';
import ComparisonLetter from 'containers/ComparisonLetter';
import TrailCompleted from 'containers/TrailCompleted';
import PageNotFound from 'containers/PageNotFound';
import RecoverPassword from 'containers/RecoverPassword';
import WritePreparation from 'containers/WritingPreparation';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from 'react-router-dom';
import C5Dashboard from 'containers/C5Dashboard';
import MessagesPage from 'containers/Messages';
import Recomendations from 'containers/Recomendations';
import EvolutionDashboard from 'containers/EvolutionDashboard';
import PracticeTestFeedback from 'containers/PracticeTestFeedback';
import PracticeTest from 'containers/PracticeTest';
import NotificationsHistory from 'containers/NotificationsHistory';
import CreateComposition from 'containers/CreateComposition';
import PedagogicalContent from 'containers/PedagogicalContent';
import CompositionFeedback from 'containers/CompositionFeedback';
import Terms from 'containers/Terms';
import Dashboard from 'containers/Dashboard';
import DevolutivaGate from 'containers/DevolutivaGate';
import ReviewedComposition from 'containers/ReviewedComposition';
import Questionnaire from 'containers/NewQuestionnaire';
import Profile from 'containers/Profile';
import SatisfactionRating from 'containers/SatisfactionRating';
import {lazyRoute} from 'utils/functions/lazyRoute';
import OlympicsPreparation from 'containers/AuthedIframe';
import FocusModeProvider from 'contexts/FocusMode';
import TeacherRevisionPending from 'containers/NewReviewed/components/TeacherRevisionPending';
import EditorPage from 'containers/EditorPage';
import ContestResult from 'containers/ContestResult';
import ErrorPage from './components/ErrorPage';

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/">
      {/* PUBLIC ROUTES */}
      <Route
        path="login"
        errorElement={<ErrorPage isAuthed={false} />}
        lazy={lazyRoute(() => import('containers/Login'))}
      />

      <Route
        path="acesso"
        element={<Access />}
        errorElement={<ErrorPage isAuthed={false} />}
      />

      <Route
        path="*"
        element={<PageNotFound />}
        errorElement={<ErrorPage isAuthed={false} />}
      />

      <Route
        path="cartas/:letterId"
        element={<ComparisonLetter />}
        errorElement={<ErrorPage isAuthed={false} />}
      />

      <Route
        path="recuperar-senha/:uidb64/:token"
        element={<RecoverPassword />}
        errorElement={<ErrorPage isAuthed={false} />}
      />

      {/* AUTHENTICATED ROUTES */}
      <Route element={<AuthRoute />}>
        <Route path="" element={<Dashboard />} errorElement={<ErrorPage />} />

        <Route
          path="perfil"
          element={<Profile />}
          errorElement={<ErrorPage />}
        />

        <Route
          path="aceite_termos"
          element={<Terms />}
          errorElement={<ErrorPage />}
        />

        <Route
          path="/praticas"
          element={<C5Dashboard />}
          errorElement={<ErrorPage />}
        />

        <Route
          path="mensagens"
          element={<MessagesPage />}
          errorElement={<ErrorPage />}
        />

        <Route
          path="evolucao"
          element={<EvolutionDashboard />}
          errorElement={<ErrorPage />}
        />

        <Route
          path="recomendacoes"
          element={<Recomendations />}
          errorElement={<ErrorPage />}
        />

        <Route
          path="notificacoes"
          element={<NotificationsHistory />}
          errorElement={<ErrorPage />}
        />

        <Route
          path="resultado-olimpiadas"
          element={<ContestResult />}
          errorElement={<ErrorPage />}
        />

        <Route path="atividades">
          <Route element={<FocusModeProvider />}>
            <Route path="simulado">
              <Route
                path=":questionnaire_id"
                element={<PracticeTest />}
                errorElement={<ErrorPage />}
              />
              <Route
                path=":questionnaire_id/resultado"
                element={<PracticeTestFeedback />}
                errorElement={<ErrorPage />}
              />
            </Route>

            <Route
              path="pesquisa/:questionnaire_id"
              element={<Questionnaire />}
              errorElement={<ErrorPage />}
            />

            <Route
              path="leitura/:pedagogical_content_id"
              element={<PedagogicalContent />}
              errorElement={<ErrorPage />}
            />

            <Route
              path="trilha/:learning_path_id/pesquisa/"
              element={<SatisfactionRating />}
              errorElement={<ErrorPage />}
            />

            <Route
              path="trilha/:learning_path_id/concluida"
              element={<TrailCompleted />}
              errorElement={<ErrorPage />}
            />

            <Route
              path="escrita/:test_id?/criar"
              element={<CreateComposition />}
              errorElement={<ErrorPage />}
            />

            <Route path="escrita/:composition_id">
              <Route
                path=""
                element={<EditorPage />}
                errorElement={<ErrorPage />}
              />
              <Route
                path="preparacao"
                element={<WritePreparation />}
                errorElement={<ErrorPage />}
              />
              <Route
                path="corrigida"
                element={<ReviewedComposition />}
                errorElement={<ErrorPage />}
              />
              <Route
                path="devolutiva/:feedback_view?"
                element={<CompositionFeedback />}
              />
              <Route
                path="nova_devolutiva/:view?"
                element={<DevolutivaGate />}
                errorElement={<ErrorPage />}
              />
            </Route>

            <Route
              path="olimpiadas/preparacao"
              element={
                <OlympicsPreparation
                  src="https://leitura-em-acao.lovable.app"
                  title="Olympics Preparation"
                />
              }
              errorElement={<ErrorPage />}
            />
          </Route>
        </Route>

        <Route
          path="revisao-pendente"
          element={<TeacherRevisionPending variant="pending" />}
          errorElement={<ErrorPage />}
        />

        <Route
          path="redacao-expirada"
          element={<TeacherRevisionPending variant="expired_composition" />}
          errorElement={<ErrorPage />}
        />

        <Route
          path="abandono"
          element={
            <TeacherRevisionPending variant="abandonment_rule_violated" />
          }
          errorElement={<ErrorPage />}
        />

        <Route
          path="biblioteca"
          element={() => (
            <iframe
              width="100%"
              height="100%"
              style={{width: '100%'}}
              src="https://letrus-com-br-7068977.hs-sites.com/bibl-letrus-estud"
              title="biblioteca letrus"
            />
          )}
          errorElement={<ErrorPage />}
        />
      </Route>
    </Route>,
  ),
);
